import { httpReducer } from "../lib/create-action";
import { GET_YOUTUBE_FOR_SHOW } from "../action_managers/shows";

const youtubeChannels = httpReducer(
  GET_YOUTUBE_FOR_SHOW,
  {
    channelsByShow: [],
  },
  {
    success: (state, action) => ({
      ...state,
      channelsByShow: {
        ...state.channelsByShow,
        [action.data.showUUID]: action.payload.resp,
      },
    }),
  }
);

export default youtubeChannels;
